const ko = {
  common: {
    login: {
      email: '이메일',
      password: '비밀번호',
      signIn: '로그인',
      forgotPassword: '비밀번호 찾기',
      signUp: '회원가입',
      errorInvalidCredentials: '이메일, 비밀번호를 다시 확인해주세요.',
      errorDuringLogin: '로그인 중 오류가 발생했습니다',
      validation: {
        emailRequired: '이메일을 입력해주세요.',
        passwordRequired: '비밀번호를 입력해주세요.',
      },
      education: {
        noneTitle: '현재는 수강중인 과정이 없습니다.',
        noneDesc: '수강 가능한 과정이 등록되면 로그인하실 수 있습니다.',
      },
    },
    join: {
      title: '회원가입',
      subtitle: '회원가입에 필요한 정보를 입력해주세요.',
      complete: '회원가입이 완료되었어요!',
      welcome: '{{name}}님, 환영합니다.',
      completeDesc: '이제 {{company}}의 다양한 기능을 이용하실 수 있습니다.',
      goHome: '홈으로 이동하기',
      name: '이름',
      email: '이메일(회원ID)',
      emailPlaceholder: '이메일을 입력해주세요.',
      phone: '휴대폰 번호',
      phonePlaceholder: '휴대폰번호를 입력해주세요.',
      phoneGlobalPlaceholder: '전화번호를 입력해주세요.',
      searchCountry: '국가를 검색해보세요.',
      password: '비밀번호',
      passwordConfirm: '비밀번호 확인',
      passwordPlaceholder: '비밀번호를 입력해주세요.',
      passwordConfirmPlaceholder: '비밀번호를 다시 입력해주세요..',
      checkDup: '중복 확인',
      verify: '인증확인',
      resendEmail: '인증 이메일 재전송',
      emailSent: '이메일이 전송되었습니다.',
      emailResent: '이메일이 재전송되었습니다.',
      emailVerification: '이메일 인증',
      emailCodePlaceholder: '인증번호를 입력해주세요.',
      emailResendCooldown: '인증 이메일 재전송은 1분 후 가능합니다.',
      emailCodeExpired: '시간이 만료되었습니다. 이메일을 확인하고 인증해주세요.',
      emailCodeInvalid: '인증 번호를 확인해주세요.',
      emailAvailable: '가입 가능한 휴대폰 번호 입니다.',
      submit: '가입하기',
      terms: '약관동의',
      acceptAllRequired: '필수 약관 모두 동의',
      tos: '(필수) 이용약관',
      privacy: '(필수) 개인정보처리방침',
      viewDetail: '자세히 보기',
      acceptAllOptional: '선택 약관 모두 동의',
      marketingEmail: '(선택) 이메일 수신 동의',
      marketingSms: '(선택) 문자 수신 동의',
      validation: {
        nameRequired: '이름을 입력해주세요.',
        nameMax: '이름은 30자 이내로 입력해주세요.',
        nameChars: '이름은 한글, 영문만 입력 가능합니다.',
        nameCharsWithSpace: '이름은 한글, 영문만 입력 가능하며 연속 공백은 사용할 수 없습니다.',
        emailRequired: '이메일을 입력해주세요.',
        emailFormat: '이메일 형식이 올바르지 않습니다.',
        phoneRequired: '휴대폰 번호를 입력해주세요.',
        phoneFormat: '010-0000-0000 형식으로 입력해주세요.',
        phoneInvalid: '올바른 휴대전화 번호를 입력해주세요.',
        phoneMax: '전화번호는 15자리 이내로 입력해주세요.',
        phoneTotalMax: '국가번호와 전화번호를 합쳐 20자 이내로 입력해주세요.',
        passwordMin: '10자 이상 입력해주세요.',
        passwordTypes: '영문, 숫자, 특수문자를 2개 이상 포함해주세요.',
        passwordRepeat: '동일한 숫자 3개 이상 연속 사용은 불가합니다.',
        passwordMatch: '비밀번호가 일치하지 않습니다.',
        emailDupRequired: '이메일 중복 확인이 완료되지 않았습니다.',
        phoneDupRequired: '휴대폰 번호 중복 확인이 완료되지 않았습니다.',
        emailDup: '이미 등록된 이메일 입니다. 다른 이메일을 입력해주세요.',
        phoneDup: '이미 등록된 휴대폰 번호 입니다. 다른 휴대폰 번호를 입력해주세요.',
      },
      error: {
        emailSend: '인증 이메일 전송 중 오류가 발생했습니다.',
        registerFailed: '등록에 실패했습니다.',
        dialogTitle: '회원가입 실패',
      },
    },
    findPassword: {
      title: '비밀번호 찾기',
      emailFormat: '잘못된 이메일 형식입니다.',
      descriptionLine1: '비밀번호를 잊으셨나요?',
      descriptionLine2: '가입하신 이메일 주소로 비밀번호 재설정 링크가 전송됩니다.',
      emailLabel: '이메일(회원ID)',
      emailPlaceholder: '이메일을 입력해주세요.',
      sendEmail: '이메일 보내기',
      toastSent: '이메일이 전송되었습니다.',
      toastFailed: '이메일 전송에 실패했습니다.',
      notRegistered: '등록된 이메일 정보가 아닙니다.',
      resent: '이메일이 재전송되었습니다.',
      resendCooldown: '이메일 재전송은 1분 후 가능합니다.',
      afterSentTitle: '입력하신 이메일주소로 비밀번호 재설정 링크를 보냈습니다.',
      resendEmail: '이메일 다시 보내기',
      checkSpam: '이메일이 도착하지 않은 경우 스팸이메일함을 확인해주세요!',
    },
    expiredToken: {
      title: '만료된 페이지 입니다.',
      descLine1: '비밀번호를 재설정 하려면,',
      descLine2: '로그인 페이지로 돌아가 비밀번호 찾기를 재실행 해주세요.',
      backToLogin: '로그인 페이지로 돌아가기',
    },
    menu: {
      my: '과정 목록',
      application: '지원 내역',
      account: '계정 정보',
    },
    cta: {
      before: {
        message: '모집은 {{date}}부터 시작됩니다.',
        button: '모집 준비 중',
      },
      closed: {
        message: '모집이 마감되었어요.',
        button: '모집 마감',
      },
      ing: {
        // message: '현재는 모집중이 아니에요.',
        button: '모집중',
      },
      none: {
        message: '현재는 모집중이 아니에요.',
        button: '모집 예정',
      },
      applyForm: {
        message: '지원 마감까지 {{time}} 남았어요.',
        button: '지원하기',
        dayShort: '일',
      },
      resume: {
        message: '작성한 지원서를 이어서 작성해보세요.',
        button: '이어서 지원하기',
      },
      startLearning: {
        message: '지금 과정을 수강할 수 있어요.',
        button: '학습하기',
      },
      submitted: {
        message: '제출이 완료되었어요.',
        button: '제출 완료',
      },
    },
    auth: {
      login: '로그인',
      logout: '로그아웃',
    },
    home: {
      browsePrograms: '교육 과정 살펴보기',
      browseBootcamps: '부트캠프 둘러보기',
      browseAllCourses: '전체강의 둘러보기',
    },
    notFound: {
      title: '링크가 만료되었거나 존재하지 않는 페이지 입니다.',
      descDesktop: '요청하신 페이지를 찾을 수 없어요. 입력하신 주소를 다시 한번 확인해주세요.',
      descMobileLine1: '요청하신 페이지를 찾을 수 없어요.',
      descMobileLine2: '입력하신 주소를 다시 한번 확인해주세요.',
      goHome: '홈으로 가기',
      notice: {
        title: '게시글을 찾을 수 없습니다.',
        descDesktop: '요청하신 공지사항이 관리자에 의해 삭제/미노출되어 접근할 수 없습니다.',
        descMobileLine1: '요청하신 공지사항이 관리자에 의해',
        descMobileLine2: '삭제/미노출되어 접근할 수 없습니다.',
        goBack: '공지사항 목록으로 가기',
      },
    },
    notice: {
      title: '공지사항',
      message: '추후 공지 예정',
    },
    empty: '아직 등록된 정보가 없어요.',
    confirm: '확인',
    cancel: '취소',
    created: '등록되었습니다.',
    retry: '다시 시도',
    loading: '데이터를 불러오는 중...',
    noMoreData: '모든 데이터를 불러왔습니다.',
    selected: '선택됨',
    viewMore: '자세히보기',
    backToList: '목록으로',
    attachments: '첨부파일',
    attachedFileAlt: '첨부파일',
    inputPlaceholder: '텍스트를 입력해 주세요.',
    selectPlaceholder: '선택해주세요.',
    noOptions: '옵션이 없습니다',
    password: {
      show: '비밀번호 보이기',
      hide: '비밀번호 숨기기',
    },
    pagination: {
      prev: '이전 페이지',
      next: '다음 페이지',
    },
    searchfield: {
      placeholder: '검색어를 입력해주세요.',
      options: {
        name: '이름',
        email: '이메일',
        phone: '휴대폰번호',
      },
    },
    checkboxLabel: '텍스트',
    attachFile: '파일 첨부',
    delete: '삭제',
    option1: '옵션1',
    option2: '옵션2',
    edit: '수정하기',
    conformityModal: {
      title: '적합성 검사 제출안내',
      desc1: '아직 적합성 검사를 제출하지 않았어요.',
      desc2: '원활한 부트캠프 수강을 위해 적합성 검사를 제출해주세요. ',
      skipToday: '오늘 그만보기',
      submit: '검사 제출하기',
    },
    programSidebar: {
      nav: {
        board: '클래스룸',
        notice: '공지사항',
        qna: 'Q&A',
        quiz: '학습퀴즈',
        project: '프로젝트',
        survey: '설문조사',
      },
      header: {
        period: '교육 기간',
        dday: 'D-{{dday}}',
      },
      roles: {
        trainee: '훈련생',
        tutor: '강사',
        manager: '매니저',
      },
    },
    mymenuLine: {
      user: '{{name}} 님',
    },

    board: {
      views: '조회수 {{value}}',
      title: '강의 자료실',
      lectureList: '강의 목록',
      noLectures: '아직 등록된 강의가 없어요.',
      notClassPeriod: '현재 수강기간이 아니에요!',
      classAvailableFrom: '{{date}}부터 수강할 수 있어요.',
      classStatus: {
        ing: '수강중',
        pre: '수강 예정',
        done: '수강 종료',
        ready: '수강 대기',
      },
      completion: {
        achieved: '수료 조건 달성',
        notAchieved: '수료 조건 미달성',
        rateLabel: '과정 수료율',
        targetLabel: '수료 조건',
      },
    },
    pageState: {
      searchEmpty: '검색된 결과가 없습니다.',
      error500: {
        line1: '일시적인 오류가 발생했습니다.',
        line2: '페이지를 새로고침한 후 다시 시도해주세요.',
      },
    },
    banner: {
      applicationPeriod: '모집 기간',
      trainingPeriod: '교육 기간',
    },
    qnaEmpty: '작성된 질문이 없어요.',
    dialog: {
      notice: '안내',
      cancelWriting: '작성 취소',
      leave: '나가기',
      leaveConfirm: '작성 중인 글이 있어요. 정말 이동하시겠어요?',
    },
    qna: {
      title: 'Q&A',
      searchPlaceholder: '궁금한 내용을 검색해보세요!',
      showMine: '내 Q&A 보기',
      create: '질문 작성하기',
      submit: '질문 등록하기',
      titleLabel: '질문명',
      titlePlaceholder: '제목에 핵심 내용을 작성해보세요. (최대 25자)',
      contentsPlaceholder:
        '- 질문 내용에 구체적인 문제 상황이 포함될수록 좋아요.\n- 문제가 있는 화면 전체를 캡쳐해서 공유 주시면 빠르게 확인할 수 있어요.\n- 먼저 유사한 질문이 있었는지 검색해보세요.\n- 답변이 달린 후에는 질문을 수정/삭제할 수 없어요.\n- 비난 및 폭언은 관리자에 의해 삭제 될 수 있어요.',
      maxFiles: '최대 3개까지 업로드 가능합니다.',
      fileHint: '20MB 미만 및 png, jpeg, jpg 파일을 올려주세요. (최대 3개)',
      privateMessage: '비밀글이므로 조회할 수 있는 권한이 없습니다.',
      validation: {
        titleRequired: '제목을 입력해주세요.',
        titleMax: '제목은 25자 이내로 작성해주세요.',
        questionRequired: '질문을 입력해주세요.',
        fileHint: '파일은 최대 3개까지, 총 20MB 이하로 업로드 가능합니다.',
        programCodeRequired: '과정 코드를 입력해주세요.',
      },
    },
    quiz: {
      title: '학습퀴즈',
      notice: {
        title: '안내',
        message: '현재 응시기간이 아니에요!',
        availableFrom: '{{date}}부터 응시 가능해요!',
        confirm: '확인',
      },
    },
    survey: {
      title: '설문조사',
      notStarted: '현재 설문조사 기간이 아니에요!',
      availableFrom: '{{date}}부터 작성 가능해요!',
      scale: {
        veryNegative: '매우 아니다',
        veryPositive: '매우 그렇다',
      },
    },
    resource: {
      noPermission: '수강권한이 없습니다.',
      nextStepTitle: '다음 스텝',
      chapter: '챕터',
      viewNext: '다음 스텝보기',
      lastStepTitle: '마지막 스텝',
      lastStepMessage: '마지막 스텝입니다.',
      goToClassroom: '클래스룸',
      reviewAgain: '다시 복습하기',
    },
    player: {
      tab: {
        curriculum: '커리큘럼',
        qna: 'Q&A',
        mentor: 'AI 멘토',
        note: 'AI 노트',
      },
      nav: {
        exit: '나가기',
      },
      move: {
        prev: '이전',
        next: '다음',
        step: '스텝',
      },
      info: {
        title: '강의정보',
        labelTitle: '강의명',
        labelTeacher: '강사명',
        labelPeriod: '수강기간',
        lifetime: '평생 소장',
      },
      session: {
        noMaterials: '해당 스텝은 강의자료가 없습니다.',
      },
      curriculum: {
        midterm: '중간평가',
        hours: '시간',
        minutes: '분',
        seconds: '초',
      },
      progress: {
        overall: '전체 진도율',
        achieved: '달성',
      },
      noteTooltip: {
        onlyVideo: '영상 스텝에서만 사용 가능해요.',
      },
    },
    qnaDetail: {
      answered: '답변완료',
      waiting: '답변대기',
      deleteTitle: '안내',
      deleteConfirm: '게시글을 정말 삭제하시겠어요?',
      deleteBtn: '삭제하기',
      deleted: '삭제되었습니다.',
      deleteFailed: '게시글 삭제에 실패했습니다.',
      admin: '관리자',
      imageAlt: 'QnA 이미지',
    },
    qnaList: {
      viewAnswer: '답변보기',
      readMore: '더 보기',
    },
    playerQna: {
      helper: '현재 학습 중인 강의에 대한 질문을 남겨주세요.',
    },
    qnaEditor: {
      minContent: '최소 10자 이상 입력해주세요.',
    },
    qnaAttach: {
      title: '첨부파일',
      attach: '파일 첨부',
      hint100: '100MB 미만 및 png, jpeg, jpg 파일을 올려주세요. (최대 3개)',
      maxFilesError: '파일은 최대 3개까지 첨부할 수 있어요.',
      dialogTitle: '안내',
      dialogMsg: '파일 첨부는 최대 100MB까지 가능합니다.',
      fileName: '파일명',
      fileSize: '용량',
    },
    answerSection: {
      title: '답변',
      preparing: '열심히 답변을 준비하고 있어요.',
      backToList: '목록으로',
    },
    surveyForm: {
      expired: '제출기간이 종료되었습니다.',
      anonymous: '설문은 익명으로 진행됩니다.',
      question: '질문',
      required: '답변 필수입니다.',
      submit: '제출하기',
      submitTitle: '제출하기',
      submitMsg1: '제출 이후에는 수정이 불가합니다.',
      submitMsg2: '확인 버튼 선택 시 제출이 완료됩니다.',
      leavingTitle: '안내',
      leavingBtn: '나가기',
      leavingMsg: '페이지를 벗어날 경우 기존에 작성된 \n내용은 삭제됩니다.',
      closedTitle: '설문마감',
      closedMsg: '설문조사가 마감되어 제출되지 않았어요.',
      list: '목록으로',
      answerPlaceholder: '답변을 입력해주세요. (공백포함 500자)',
    },
    quizStatus: {
      scheduled: '예정',
      notTaken: '미응시',
      notSubmitted: '미제출',
      submitted: '제출 완료',
      inProgress: '진행중',
    },
    quizLabels: {
      period: '응시 기간',
      score: '점수',
      grading: '현재 채점 진행중이에요. 조금만 기다려주세요.',
      of: '/',
      pts: '점',
      finalScore: '최종 점수',
      total100: '전체 총점 100점',
      ended: '응시기간이 종료되었어요.',
    },
    quizItem: {
      typeMulti: '객관식',
      typeSubjective: '주관식',
      pointSuffix: '점',
      answerPlaceholder: '문제에 대한 정답을 입력해주세요.',
    },
    ide: {
      dialog: {
        submitCodingQuizTitle: '코딩 평가 제출',
        submitCodingQuizLine1: '제출 후 채점은 한번만 가능해요.',
        submitCodingQuizLine2: '제출하시겠어요?',
      },
      actions: {
        run: '실행',
        submit: '제출하기',
        checkSolution: '정답 확인하기',
        submitThenGrade: '제출 후 채점하기',
        reset: '초기화하기',
        cancel: '취소',
      },
      resetDialog: {
        title: '정말로 초기화하시겠어요?',
        line1: '해당 스텝에서 작업했던 작성코드가 삭제되고',
        line2: '초기 제공 파일만 남은 상태로 돌아가요.',
        resetNow: '초기화하기',
        toastSuccess: '작성 내역이 초기화되었습니다.',
      },
      mobileTab: {
        practice: '실습 내용',
        codingQuiz: '평가 내용',
        editor: '코드 에디터',
      },
      terminal: {
        aiGrading: 'AI가 열심히 채점 중이에요! 잠시만 기다려 주세요.',
        errorPrefix: '오류 발생:',
        placeholder: {
          practice: '코드 실행 후 다음 스텝을 진행할 수 있어요!',
          coding_quiz: '코드 실행 후 채점을 완료해야 다음 스텝으로 넘어갈 수 있어요.',
        },
        tab: {
          execution: '실행 내역',
          input: '데이터 입력',
          submission: '채점 내역',
        },
      },
      inputTerminal: {
        placeholderLine1: '데이터를 입력해주세요.',
        placeholderLine2: 'Enter를 누르면 다음 데이터를 입력할 수 있어요.',
      },
      filetree: {
        title: '파일 트리',
        root: 'Projects',
      },
      description: {
        practiceLabel: '실습 정보',
        quizLabel: '평가 정보',
        difficulty: '난이도',
        beginner: '입문',
        recommendedTime: '권장 풀이 시간',
        timeFormat: 'mm분 ss초',
      },
      codeReview: {
        header: 'AI 코드리뷰',
        errorPrefix: '오류 발생:',
        reviewing: '지금까지 작성한 코드를 AI가 리뷰중이에요...',
        analyzed: '분석 완료!',
        intro1: '멋사 코드리뷰는 AI에 기반한 리뷰페이지에요.',
        intro2: '작성한 코드를 멋사 코드리뷰에게 리뷰받아 보세요!',
        helpful: '멋사 코드리뷰가 도움이 되셨나요?',
        leaveTitle: '의견을 남겨주세요.',
        leaveQuestion: 'AI 코드 리뷰의 어떤 부분이 불편하셨나요?',
        leaveDesc: '사용자 여러분의 소중한 의견을 듣고자 합니다.',
        placeholder: 'AI 코드 리뷰에 대한 자유로운 의견을 남겨주세요.',
        submitted: '의견이 제출되었습니다.',
      },
    },
    fileArea: {
      invalidExtension: '허용되지 않는 파일 형식입니다. 지정된 형식만 업로드할 수 있어요.',
      sizeExceeded: '파일 용량이 너무 큽니다. 최대 {{mb}}MB까지 가능합니다.',
      remove: '파일 삭제',
      uploadedAlt: '업로드된 파일',
    },
    technology: {
      note: {
        title: '자료실',
        subtitle: '강의에 필요한 자료를 확인해주세요.',
        chapter: '챕터 {{order}}. {{title}}',
        noMaterials: '강의 자료가 없어요.',
        links: '관련 링크',
        downloads: '다운로드 파일',
      },
      badge: {
        note: '자료실',
        survey: '설문',
        quiz: '일반 평가',
        codingQuiz: '코딩 평가',
        practice: '실습',
      },
      quiz: {
        header: '평가',
        headerTraining: '훈련평가',
        submitSuccess: '평가 제출이 완료되었습니다.',
        submitSuccessTraining: '훈련평가 제출이 완료되었습니다.',
        explanationTitle: '문제해설',
        answer: {
          correct: '정답',
          incorrect: '오답',
        },
        enlargedAlt: '확대된 이미지',
        fileUpload: {
          label: '파일 업로드',
          placeholder: '파일 첨부(최대 300MB의 pdf / ppt / zip)',
          sizeExceeded: '파일 크기는 최대 300MB까지 업로드 가능합니다.',
          uploadFail: '업로드에 실패했습니다.',
          downloadFail: '파일 다운로드에 실패했습니다.',
        },
      },
      survey: {
        header: '설문조사',
        weeksTitle: '{{weeks}}차 설문조사',
        submitSuccess: '설문조사 제출이 완료되었습니다.',
        answerPlaceholder: '답변을 입력해 주세요. (공백포함 300자)',
        questionBadge: '질문 {{num}}',
      },
    },
    projectSubmit: {
      attachments: '제출 자료',
      title: '제출하기',
      desc: '최종 제출 후에는 수정이 불가합니다.',
      linkLabel: '첨부된 링크주소',
      linkPlaceholder: 'https://를 포함한 링크를 입력해주세요.',
      linkTitle: '링크 첨부',
      fileLabel: '첨부된 파일명',
      fileTitle: '파일 첨부',
      filePlaceholder: '파일을 첨부해주세요. ( 최대 300MB의 pdf, ppt, pptx, zip 파일만 가능 )',
      confirmLine1: '각 항목의 정보를 확인했으며,',
      confirmLine2: '프로젝트를 제출하겠습니다.',
      submit: '제출하기',
    },
    project: {
      title: '프로젝트',
      notPeriodTitle: '안내',
      notPeriodLine1: '현재 제출 기간이 아니에요!',
      notPeriodLine2: '{{date}}에 제출 가능해요!',
      confirm: '확인',
      guideTitle: '제출 가이드',
      status: {
        scheduled: '예정',
        submitted: '제출 완료',
        notSubmitted: '미제출',
        inProgress: '진행중',
      },
      period: '제출 기간',
      deadlineToday: '금일 {{time}} 마감',
      deadlineDays: '제출 마감까지 {{days}}일 남음',
      cancel: '취소',
      submit: '제출하기',
      backToList: '목록으로',
      leaveTitle: '안내',
      leaveLine1: '제출하지 않고 나가시겠어요?',
      leaveLine2: '현재까지 입력된 내용은 삭제됩니다.',
      leave: '나가기',
      keep: '계속 작성하기',
    },
    reset: {
      title1: '개인정보 보호를 위해',
      title2: '비밀번호를 재설정해주세요.',
      password: '새 비밀번호',
      confirmPassword: '새 비밀번호 확인',
      submit: '변경하기',
      toastSuccess: '비밀번호 재설정이 완료되었습니다.',
      toastError: '비밀번호 재설정에 실패했습니다.',
      apiError: '비밀번호 변경에 실패하였습니다.',
      validation: {
        passwordRequired: '새 비밀번호를 입력해주세요',
        passwordMin: '10자 이상 입력',
        passwordComplexity: '영문/숫자/특수문자 2개 이상 포함',
        passwordRepeat: '동일한 숫자 3개 이상 연속 사용 불가',
        confirmRequired: '비밀번호 확인을 입력해주세요',
        match: '비밀번호가 일치하지 않습니다',
      },
    },
    mymenu: {
      inProgressApplications: '신청중인 지원서',
      browseCourses: '과정 목록',
      noApplications: '신청중인 지원서가 없어요.',
      goBrowse: '과정 둘러보러 가기',
      noPrograms: '아직 등록된 과정이 없어요.',
    },
    my: {
      filter: {
        all: '전체',
        progress: '수강중',
        scheduled: '수강 예정',
        completed: '수강 종료',
      },
    },
    application: {
      pending: {
        line1: '작성중인 지원서가 있어요.',
        line2: '지원서 작성을 마무리 해주세요!',
        cta: '이어서 작성하기',
      },
      submitted: '지원서를 검토중이에요.',
      passed: {
        line1: '합격자로 선정되셨어요!',
        line2: '수강 확정 후 과정목록에서 확인할 수 있어요.',
      },
      spared: {
        line1: '{{name}}님은 예비 합격자로 선정되셨어요.',
        line2: '결원이 발생할 경우 순차적으로 추가 등록 안내를 드릴 예정이에요.',
        line3:
          '안내는 최대 수강 시작 후 일주일 이내로 진행되며, 개별 연락을 통해 확정 여부를 안내드릴게요.',
      },
      failed: {
        line1: '지원서 검토 결과, 아쉽게도 {{name}}님을 모시지 못하게되었어요.',
        line2: '다음 기회에 다시 지원해 주세요.',
      },
      canceledReason: '취소사유',
      filters: {
        all: '전체',
        inProgress: '지원중',
        result: '지원 결과',
        canceled: '지원 취소',
      },
      labels: {
        recruitPeriod: '모집 기간',
        announceDate: '합격 발표일',
        announceDesc: '지원일 기준 최대 7일 이내 개별 안내',
      },
      statusLabel: {
        apply: '지원',
        review: '검토',
        pass: '합격',
        spared: '예비합격',
        fail: '미선정',
        cancel: '지원취소',
        form: '지원서 작성',
        formReview: '지원서 검토',
      },
      status: {
        pendingLabel: '지원중',
        submittedLabel: '검토중',
        passedLabel: '합격',
        sparedLabel: '예비합격',
        failedLabel: '미선정',
        canceledLabel: '지원취소',
      },
      cancel: {
        selectReason: '취소 사유를 선택해주세요.',
        inputReason: '취소 사유를 입력해주세요.',
        button: '지원 취소하기',
        short: '지원 취소',
        reason: {
          personal: '개인 사정으로 인해 수강이 어려움',
          schedule: '일정이 맞지 않아 지원을 취소',
          duplicate: '비슷한 다른 과정에 이미 지원',
          mistake: '지원서에 잘못된 정보를 입력',
          interest: '현재 과정에 대한 관심이 줄었음',
          etc: '기타',
        },
        notice: '지원 취소가 확정된 이후에는 지원서를 복구할 수 없어요.',
        toast: '지원 취소되었습니다.',
      },
    },
    programItem: {
      period: '교육 기간',
      lectureCount: '강의 개수',
      progressRate: '진도율',
      completionNoteAll100: '모든 강의 진도율 100% 시 수료',
      completionNoteAvg: '전체 강의의 평균 진도율 {{rate}}% 이상 달성시 수료',
      lectureSuffix: '{{count}}강',
      lectureCountValue: '{{count}}개',
      completionBadge: {
        achieved: '수료 달성',
        notAchieved: '수료 미달',
      },
    },
    sidebar: {
      menu: '메뉴',
    },
    companyInfo: {
      links: {
        tos: '이용약관',
        privacy: '개인정보처리방침',
      },
      labels: {
        name: '상호명',
        ceo: '대표',
        phone: '연락처',
        businessNumber: '사업자 번호',
        mailOrderNumber: '통신판매업 신고번호',
        address: '주소',
      },
    },
    account: {
      title: '계정 정보',
      section: {
        member: '회원정보',
        security: '보안 설정',
        marketing: '마케팅 수신 동의',
        settings: '설정',
      },
      labels: {
        name: '이름',
        email: '이메일',
        password: '비밀번호',
        passwordConfirm: '비밀번호 확인',
        marketingEmail: '(선택) 이메일 수신 동의',
        marketingSms: '(선택) 문자 수신 동의',
        language: '언어',
      },
      placeholders: {
        password: '10자리 이상 문자, 숫자, 특수문자',
        passwordConfirm: '새 비밀번호 다시 입력',
      },
      modal: {
        title: '비밀번호 변경',
      },
      actions: {
        changePassword: '비밀번호 변경',
        submitChange: '변경하기',
      },
      toast: {
        saveFailed: '저장에 실패했습니다. 다시 시도해주세요.',
        changePasswordSuccess: '비밀번호 변경이 완료되었습니다.',
      },
    },
    apply: {
      header: {
        title: '지원서 작성',
        stepSuffix: '단계',
      },
      footer: {
        saveTemp: '임시저장',
        next: '다음',
        agreeAndContinue: '동의하고 계속하기',
        submitFinal: '최종 제출하기',
      },
      exitModal: {
        title: '작성 취소 안내',
        line1: '저장하지 않은 내용이 있습니다.',
        line2: '저장 후 나가시겠습니까?',
        continue: '계속 작성하기',
        saveAndExit: '저장 후 나가기',
      },
      lastConfirm: {
        title: '최종 제출하기',
        line1: '최종 제출 후에는 수정할 수 없습니다.',
        line2: '제출하시겠습니까?',
        button: '최종 제출하기',
        submitting: '업로드 중...',
        submittingDescription: '파일을 업로드하고 있습니다.\n잠시만 기다려주세요.',
      },
      toast: {
        saved: '저장되었습니다.',
      },
      error: {
        generic: '오류가 발생헀습니다. 다시 시도해주세요.',
        fileUpload: '파일 업로드에 실패했습니다. 파일을 확인하고 다시 시도해주세요.',
      },
      badge: {
        required: '필수',
        multiSelect: '복수선택가능',
      },
      prev: '이전',
      phase01: {
        title: '지원자 정보를 확인해주세요.',
      },
      labels: {
        name: '이름',
        emailAddress: '이메일 주소',
        phone: '연락처',
      },
      terms: {
        allAgree: '필수 약관에 모두 동의합니다.',
        requiredPolicy1: '[필수] 개인정보 수집 및 이용 동의',
        requiredPolicy2: '[필수] 개인정보 제 3자 제공 동의',
      },
      placeholders: {
        input: '내용을 입력해주세요.',
      },
      lengthGuide: {
        both: '/최소 {{min}}, 최대 {{max}}자',
        min: '/최소 {{min}}자',
        max: '/최대 {{max}}자',
      },
      charSuffix: '자',
      validation: {
        required: '필수 항목입니다.',
        minLength: '최소 {{min}}자 이상 작성',
        maxLength: '최대 {{max}}자 이하 작성',
        atLeastOne: '하나 이상 선택해주세요.',
        invalid: '유효하지 않은 값입니다.',
      },
      file: {
        attachPrompt: '파일을 첨부해주세요.',
        types: '(pdf, zip, jpg, png)',
      },
      complete: {
        title: '제출이 완료되었어요.',
        labels: {
          programName: '과정명',
          submittedAt: '최종 제출 일시',
        },
        button: {
          viewApplications: '지원 내역 보기',
        },
      },
    },
  },
}

export default ko
